'use strict';

function Numeral() {
  const BYTES = 1024;

  const FORMATS = [ 'KB', 'MB', 'GB', 'TB' ];

  this.convert = function(value) {
    let iteration = -1;
    let bytes = 0;
    let best = 0;
    let prev = 0;
    let tail = 0;
    while (tail === 0) {
      best = prev;
      bytes = getBytes(++iteration);
      prev = value / bytes;
      tail = prev % 1;
    }
    return best + FORMATS[iteration - 1];
  };

  function getBytes(k) {
    let total = BYTES;
    let i = 0;
    while (i < k) {
      total *= BYTES;
      i++;
    }
    return total;
  }
}

export default new Numeral();
